// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

//
// FARSA
//

// Responsive nav
// Selection of HTML objects
const burger = document.querySelector('.mobile-navigation-toggle');
const nav = document.querySelector('.menu-primary-navigation-container');
const overlay = document.querySelector('.overlay');

// Defining a function
function toggleNav() {
  burger.classList.toggle('open');
  nav.classList.toggle('nav-active');
  overlay.classList.toggle('active');
}

// Calling the function after click event occurs
burger.addEventListener('click', function() {
  toggleNav();
});



// WEBPACK FOOTER //
// ./scripts/main.js